import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import routes from '../routes/routes'
import confirmService from '../services/confirm.service'
import categoryService from '../services/category.service'
import categoryApi, { CategoryData } from '../apis/category.api'
import { ConfirmParams } from '../components/Confirm/Confirm.state'
import { ActionName } from '../components/Actions'
import Card from '../components/Card'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import TableHorizontal, { TableHorizontalData, TableHorizontalHeader } from '../components/TableHorizontal'
import Button from '../components/Button'
import HeadingRow from '../components/HeadingRow'

interface CategoriesProps extends RouteComponentProps {}

interface CategoriesState {
  categories: TableHorizontalData<CategoryData>[]
}

class Categories extends Component<CategoriesProps, CategoriesState> {
  headers: TableHorizontalHeader[] = [
    { heading: i18n("Name"), path: 'name' },
    { heading: i18n("Type"), path: 'unit.name' },
    { heading: i18n("Items"), path: 'itemsCount' },
    { heading: i18n("Updated at"),
      path: 'updatedAt',
      date: true,
      tooltip: ['updatedUser.username']
    },
    { heading: i18n("Actions") }
  ]

  constructor (props: CategoriesProps) {
    super(props)
    this.state = {
      categories: []
    }
    this.handleCreateClick = this.handleCreateClick.bind(this)
    this.handleActionClick = this.handleActionClick.bind(this)
  }

  handleCreateClick () {
    this.props.history.push(routes.categoryCreate)
  }

  handleActionClick (id: number, action: ActionName) {
    if (action === 'edit') {
      const pathname = routes.categoryEdit
      const state = { id }
      this.props.history.push({ pathname, state })
    } else if (action === 'delete') {
      const confirm: ConfirmParams = {
        id,
        type: 'warning',
        question: i18n('Are you sure to delete the category?'),
        confirmText: i18n('Yes'),
        cancelText: i18n('No'),
        onConfirm: () => this.handleDeleteConfirm(id)
      }
      confirmService.push(confirm)
    }
  }

  handleDeleteConfirm (id: number) {
    categoryApi.delete(id, meta => {
      if (!meta) return
      const categories = categoryService.delete(this.state.categories, id)
      this.setState({ categories })
    })
  }

  listCategories () {
    categoryApi.list(categories => {
      if (!categories) return
      const categoriesData = categoryService.tableHorizontalData(categories)
      this.setState({ categories: categoriesData })
    })
  }

  componentDidMount () {
    this.listCategories()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <Card>
            <HeadingRow
              heading={i18n("Categories")}
              doc='categories'>
              <Button
                text={i18n("Create")}
                onClick={this.handleCreateClick} />
            </HeadingRow>
            <TableHorizontal
              headers={this.headers}
              data={this.state.categories}
              onActionClick={this.handleActionClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(Categories)
